import { type Filter, FilterId } from '../types/filters';
import type { TaxonomyConfig } from '../types/taxonomy';
import { validateRoleFilters } from './validateRoleFilters';
import { validateSkillFilters } from './validateSkillFilters';

export const validateTaxonomyFilters = ({
  filters,
  taxonomyConfig,
  showTaxonomyVersionToast,
}: {
  filters: [FilterId, Filter][];
  taxonomyConfig: TaxonomyConfig;
  showTaxonomyVersionToast?: (toastId: string, filterId: FilterId) => void;
}): [FilterId, Filter][] => {
  const { skillTaxonomyVersion, roleTaxonomyVersion } = taxonomyConfig;

  const skillValidated = validateSkillFilters({
    filters,
    taxonomyVersion: skillTaxonomyVersion,
    onRemoveFilter: () => {
      showTaxonomyVersionToast?.('skill-filters-removed', FilterId.SKILL);
    },
  });

  const roleValidated = validateRoleFilters({
    filters: skillValidated,
    taxonomyVersion: roleTaxonomyVersion,
    onRemoveFilter: () => {
      showTaxonomyVersionToast?.('role-filters-removed', FilterId.ROLE);
    },
  });

  return roleValidated;
};
